<template>
  <app-modal name="actions-invoice-modal" :width="isDefault ? '30%' : '90%'" :title="title" body-class="actions-invoice-modal-body" @before-open="beforeOpen"
    @before-close="beforeClose" hide-footer>
    <actions-invoice-form ref="form" :flag="flag" :invoice="invoice" :seller-setting-list="sellerSettingList"
      @on-change-currency-code="onChangeCurrencyCode" @on-change-invoice-type="onChangeInvoiceType"
      @on-input-modified="invoiceDataChanged" />
    <dynamic-table ref="table" v-if="showTable" :data="tableData" :invoiceType="invoiceType"
      :currency-code="currencyCode" :disabled-add="isAdjustIncreaseDecrease" :is-adjustment="isAdjustIncreaseDecrease"
      :seller-setting-list="sellerSettingList" :cached_total_amount_with_tax="invoice.total_amount_with_tax"
      :cached_total_amount_without_tax="invoice.total_amount_without_tax" :cached_total_tax_mount="invoice.tax_amount"
      @onTableChange="tableChangeHandler" />
    <div class="text-right pt-3">
      <button class="btn btn-sm" type="button" :class="isDefault ? 'btn-outline-secondary' : 'btn-outline-primary'"
        @click="onClick" :disabled="isLoading">
        {{ isDefault ? this.$t('app.close') : this.$t('actions.form.actions.preview') }}
      </button>
      <button v-if="isShowSaveDraft" class="btn btn-sm btn-outline-primary ml-2" type="button"
        @click="handleEditDraftInvoice" :disabled="isLoading">
        Lưu nháp
      </button>
      <app-btn-submit :is-submitting="isLoading" :css="'btn btn-primary btn-sm ml-2'" :text="renderTextSubmit"
        @on-click="onSubmit" />
    </div>
  </app-modal>
</template>
<script>
import { mapState } from 'vuex';
import DateTimeUtils from '@/utils/datetime';
import NumericUtils from '@/utils/numeric';
import ToastUtils from '@/utils/toast';
import { getKeyByValue } from '@/utils/helper';
import { INVOICE_ACTIONS, DEFAULT_TABLE, PRODUCT_TYPE, INVOICE_PRODUCT_SERVICE_TABLE_ERROR, DECREE_ROW } from '@/app-constant';
import ReleaseInvoiceMixin from '@/mixins/release-invoice';
import EInvoiceServiceProxy from '@/store/proxies/e-invoice-service-proxy';
import { buildProductPayloadFromInvoiceLine } from '@/services/productService';
import {
  EInvoiceProxy,
  PublishedInvoiceProxy,
} from '@/store/proxies/e-invoice';
import AppModal from '@/components/app-modal/';
import AppBtnSubmit from '@/components/app-button/index';
import DynamicTable from '@/components/dynamic-table/dynamic-table';
import ActionsInvoiceForm from '@/portal-components/invoice/actions-invoice/actions-invoice-form';
import InvoiceProxy from '@/store/proxies/invoice-proxy';
import ProductProxy from '@/store/proxies/product-proxy';
import ProductCategoryProxy from '@/store/proxies/product-category-proxy';

const vatInvoice = '1';
const VND = 'VND';
const DEFAULT_PRODUCT_CATEGORY_NAME = 'HÀNG HÓA';
let prevInvalidFields = []

export default {
  name: 'ActionsInvoiceModal',
  mixins: [ReleaseInvoiceMixin],
  components: {
    AppModal,
    ActionsInvoiceForm,
    AppBtnSubmit,
    DynamicTable,
  },
  data() {
    return {
      flag: '',
      title: '',
      invoice: {},
      tableData: [],
      isLoading: false,
      invoiceType: vatInvoice,
      invoiceHasChanged: false,
      currencyCode: VND,
      defaultProductCategoryIdPromise: null,
    };
  },
  computed: {
    ...mapState(['activeAnnouncementLines', 'sellerSettingList']),

    renderTextSubmit() {
      switch (this.flag) {
        case INVOICE_ACTIONS.EXPLAIN_INVOICE:
          return this.$t('actions.form.actions.confirm');
        default:
          return this.$t('actions.form.actions.sign');
      }
    },

    isShowSaveDraft() {
      return [
        INVOICE_ACTIONS.COPY_INVOICE,
        INVOICE_ACTIONS.ISSUE_INVOICE,
      ].includes(this.flag);
    },

    showTable() {
      return [
        INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE,
        INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE,
        INVOICE_ACTIONS.COPY_INVOICE,
        INVOICE_ACTIONS.ISSUE_INVOICE,
      ].includes(this.flag);
    },

    isDefault() {
      return [
        INVOICE_ACTIONS.EXPLAIN_INVOICE,
      ].includes(this.flag);
    },

    isShowDefaultTable() {
      return [
        INVOICE_ACTIONS.COPY_INVOICE,
        INVOICE_ACTIONS.ISSUE_INVOICE,
      ].includes(this.flag);
    },

    isAdjustIncreaseDecrease() {
      return this.flag === INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE;
    },

    isAdjustInfo() {
      return this.flag === INVOICE_ACTIONS.ADJUST_INFO;
    },
  },
  created() {
    this.$bus.on('actions-invoice', this.onSubmit);
    this.$bus.on('close-create-invoice-modal', this.onCancel);
    this.DATA_ERROR_MSG = INVOICE_PRODUCT_SERVICE_TABLE_ERROR(this)
  },
  beforeDestroy() {
    this.$bus.off('actions-invoice', this.onSubmit);
    this.$bus.off('close-create-invoice-modal', this.onCancel);
  },
  methods: {
    initialize() {
      this.invoice = {};
      this.tableData = [];
      this.isLoading = false;
      this.invoiceType = vatInvoice;
      this.currencyCode = VND;
      this.invoiceHasChanged = false;
      this.defaultProductCategoryIdPromise = null;
      if (this.$refs.form) {
        this.$refs.form.initialize(this.formModel);
      }
    },
    /**
     * Quy tắc xác định rate / custom_tax_rate dùng chung cho cả 2 nguồn (lines_fk & content).
     * - rateRaw: giá trị thuế số/chuỗi (e.g. line.rate hoặc item.PRODUCT_VAT_RATE).
     * - rateName: nhãn thuế đặc biệt (e.g. 'KKKNT', 'KHAC', 'NONE').
     */
    resolveRate(rateRaw, rateName) {
      const ALLOWED_RATES = ['0', '5', '8', '10', 'NONE', 'KHAC', 'KKKNT'];
      const STANDARD_RATES = ['0', '5', '8', '10'];
      const cleanName = ((rateName != null ? rateName : '') + '').trim();

      if (rateRaw === null || rateRaw === undefined || rateRaw === '') {
        return {
          rate: cleanName && ALLOWED_RATES.includes(cleanName) ? cleanName : 'NONE',
          custom_tax_rate: 0,
        };
      }

      const rateString = String(rateRaw).trim();
      if (cleanName && ALLOWED_RATES.includes(cleanName) && !STANDARD_RATES.includes(cleanName)) {
        return {
          rate: cleanName,
          custom_tax_rate: cleanName === 'KHAC' ? (Number(rateString) || 0) : 0,
        };
      }
      if (ALLOWED_RATES.includes(rateString)) {
        return { rate: rateString, custom_tax_rate: 0 };
      }
      return { rate: 'KHAC', custom_tax_rate: Number(rateString) || 0 };
    },

    /** Map 1 item từ lines_fk (raw shape của BE) ra row của table. */
    mapLineFkToRow(line, index) {
      const { rate, custom_tax_rate } = this.resolveRate(line.rate, line.rate_name);
      return {
        id: index,
        stt: index + 1,
        name: line.name || null,
        product_id: line.product_id || null,
        unit: line.unit || null,
        type: line.type || PRODUCT_TYPE.PRODUCT,
        quantity: Number(line.quantity) || null,
        price: Number(line.price) || null,
        tax_money: Number(line.tax_money) || null,
        subtotal: Number(line.subtotal) || null,
        total: Number(line.total) || null,
        custom_tax_rate,
        method: this.isAdjustIncreaseDecrease ? 'TANG' : (line.method || null),
        rate,
      };
    },

    /** Map 1 item từ content (legacy shape với keys PRODUCT_*) ra row của table. */
    mapContentItemToRow(item, index) {
      const { rate, custom_tax_rate } = this.resolveRate(item.PRODUCT_VAT_RATE, item.PRODUCT_VAT_RATE_NAME);
      return {
        id: index,
        stt: item.PRODUCT_NO || null,
        name: item.PRODUCT_DESC || null,
        product_id: item.PRODUCT_ID || item.product_id || null,
        unit: item.PRODUCT_UNIT || null,
        type: item.PRODUCT_TYPE || PRODUCT_TYPE.PRODUCT,
        quantity: Number(item.PRODUCT_QUANTITY) || null,
        price: Number(item.PRODUCT_UNIT_PRICE) || null,
        tax_money: Number(item.PRODUCT_TAX_AMOUNT) || null,
        subtotal: Number(item.PRODUCT_AMOUNT) || null,
        total: Number(item.PRODUCT_TOTAL_AMOUNT) || null,
        custom_tax_rate,
        method: this.isAdjustIncreaseDecrease ? 'TANG' : null,
        rate,
      };
    },

    /** Parse content (chuỗi JSON hoặc array) thành mảng object an toàn. */
    parseContent(rawContent) {
      if (!rawContent) return [];
      if (Array.isArray(rawContent)) return rawContent;
      if (typeof rawContent !== 'string') return [];
      try {
        const fixed = rawContent
          .replace(/'/g, '"')
          .replace(/([{,]\s*)([A-Za-z0-9_]+)\s*:/g, '$1"$2":');
        const parsed = JSON.parse(fixed);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        console.warn('Invoice.content không parse được JSON:', e);
        return [];
      }
    },

    generateTableData() {
      // Ưu tiên lines_fk (raw data từ BE) — khi save draft, content có thể là "[]" trong khi lines_fk vẫn có dữ liệu.
      // Fallback parse content cho hóa đơn cũ.
      const linesFk = Array.isArray(this.invoice.lines_fk) ? this.invoice.lines_fk : [];
      const tableData = linesFk.length > 0
        ? linesFk.map((line, idx) => this.mapLineFkToRow(line, idx))
        : this.parseContent(this.invoice.content).map((item, idx) => this.mapContentItemToRow(item, idx));

      const finalData = tableData.length > 0
        ? tableData
        : (this.isShowDefaultTable ? [...DEFAULT_TABLE] : []);

      if (this.invoiceType === '2') {
        finalData.push(DECREE_ROW(finalData.length));
      }

      this.tableData = finalData;
      this.invoice.lines = finalData;
    },
    beforeOpen(event) {
      const { key, title } = event.option;
      this.flag = key;
      this.title = title;


      const item = event.item;

      this.invoice = {
        ...item,
        status: item.status || item.invoice_type,
        invoice_issued_date: item.invoice_issued_date || item.issued_date,
      };

      this.currencyCode = item.currency_unit;

      if (item.template_package_order && item.template_package_order.template_type_obj) {
        const templateCode = item.template_package_order.template_type_obj.template_code ?
          item.template_package_order.template_type_obj.template_code : '';
        if (templateCode) {
          this.invoiceType = getKeyByValue(this.activeAnnouncementLines.list_template_code, templateCode);
        }
      } else {
        const serial = item.invoice_serial;
        if (serial) {
          const templateCode = getKeyByValue(this.activeAnnouncementLines.list_common_code, serial, true);
          const invoiceType = getKeyByValue(this.activeAnnouncementLines.list_template_code, templateCode);

          if (templateCode && invoiceType) {
            this.invoice.invoice_common_code = `${invoiceType}${serial}`;
            this.invoice.template_code = templateCode;
            this.invoice.invoice_type = invoiceType;
            this.invoiceType = invoiceType;
          }
        }
      }
      this.$bus.emit('display-invoice-form-model', true);
      this.generateTableData();
    },
    beforeClose(event) {
      if (this.invoiceHasChanged && (this.showTable || this.isAdjustIncreaseDecrease || this.isAdjustInfo)) {
        event.stop();
        if (this.isShowSaveDraft) {
          this.$modal.show('save-invoice-draft-modal', {
            title: this.$t('invoice.headsUp'),
            text: this.$t('invoice.saveDraftConfirmMsg'),
            okText: 'Lưu nháp',
            okClass: 'btn btn-primary btn-sm',
            cancelText: this.$t('dialog.continue'),
            cancelClass: 'btn btn-danger btn-sm',
            onOk: async () => {
              await this.handleEditDraftInvoice();
              if (this.$route.name !== 'main.status.draft') this.$router.push({ name: 'main.status.draft', params: this.$route.params, query: { ...this.$route.query, statistics: 'HIDE' } }).catch(() => { });
              // else this.$bus.emit('on-reload-page');
            },
          });
        } else {
          this.$modal.show('save-invoice-draft-modal', {
            title: this.$t('invoice.headsUp'),
            text: this.$t('invoice.reviewDraftMsg').replace('%s', this.title),
            cancelText: this.$t('dialog.continue'),
            cancelClass: 'btn btn-danger btn-sm',
          });
        }
      } else this.initialize();
    },
    onCancel() {
      this.initialize();
      this.$modal.hide('actions-invoice-modal', { isCancel: true });
    },
    detectValidationErrors(bypassUnit = false) {
      const tableErrorMsg = this.validateLineItem();
      const detectedErrors = Object.entries(tableErrorMsg).reduce((acc, [key, value]) => {
        const hasErrors = (Array.isArray(value) ? value.length > 0 : !!value)
        if (hasErrors) {
          if (bypassUnit && key === 'MISSING_UNIT') {
            return acc;
          }
          if (!['MISSING_METHOD', 'NON_NEGATIVE_DECREASE', 'EMPTY_TABLE'].includes(key)) {
            acc.MISSING_FIELDS.keys.push(this.DATA_ERROR_MSG[key])
            acc.MISSING_FIELDS.values.push(...value)
          } else if (key === 'NON_NEGATIVE_DECREASE') {
            acc.NON_NEGATIVE_DECREASE.push(...value)
          } else if (key === 'MISSING_METHOD') {
            acc.MISSING_METHOD.push(...value)
          }
        }
        return acc
      }, {
        MISSING_FIELDS: {
          keys: [],
          values: []
        },
        NON_NEGATIVE_DECREASE: [],
        MISSING_METHOD: []
      })

      const { MISSING_FIELDS, MISSING_METHOD, NON_NEGATIVE_DECREASE } = detectedErrors;

      if (MISSING_FIELDS.keys.length) {
        ToastUtils.showToast('error', `${MISSING_FIELDS.keys.join('/')} không được bỏ trống.`);
        this.$refs.table.forceInvalidateFields(MISSING_FIELDS.values)
      } else if (MISSING_METHOD.length) {
        ToastUtils.showToast('error', this.DATA_ERROR_MSG.MISSING_METHOD)
        this.$refs.table.forceInvalidateFields(MISSING_METHOD)
      } else if (NON_NEGATIVE_DECREASE.length) {
        ToastUtils.showToast('error', this.DATA_ERROR_MSG.NON_NEGATIVE_DECREASE)
        this.$refs.table.forceInvalidateFields(NON_NEGATIVE_DECREASE)
      }

      return MISSING_FIELDS.values.concat(MISSING_METHOD, NON_NEGATIVE_DECREASE)
    },
    validateLineItem() {
      let errorsInTable = { // keys are error types and values are table coords [ field, row id ]
        EMPTY_TABLE: false,
        MISSING_NOTE: [],
        MISSING_NAME: [],
        MISSING_METHOD: [],
        MISSING_DISCOUNT: [],
        MISSING_UNIT: [],
        MISSING_QUANTITY: [],
        MISSING_PRICE: [],
        NON_NEGATIVE_DECREASE: []
      };

      if (this.flag === INVOICE_ACTIONS.ADJUST_INFO) { // disable validation for adjust info
        return errorsInTable;
      }

      if (this.tableData.length === 0) {
        errorsInTable.EMPTY_TABLE = true
        return errorsInTable
      }

      for (let i = 0; i < this.tableData.length; i++) {
        const row = this.tableData[i];
        if (row.type === PRODUCT_TYPE.NOTE && !row.name) {
          errorsInTable.MISSING_NOTE.push(['name', row.id])
        } else if (row.type === PRODUCT_TYPE.DISCOUNT && !row.name) {
          errorsInTable.MISSING_DISCOUNT.push(['name', row.id])
        } else if (row.type === PRODUCT_TYPE.PRODUCT) {
          if (this.isAdjustIncreaseDecrease) {
            if (!row.name) {
              errorsInTable.MISSING_NAME.push(['name', row.id])
            }
          } else {
            // Tạm không bắt buộc Đơn vị (FE) — để BE xử lý / kiểm tra.
            errorsInTable = ['name', 'quantity', 'price'].reduce((acc, k) => {
              if (!row[k]) {
                if (k === 'name') {
                  acc.MISSING_NAME.push(['name', row.id])
                }
                else if (k !== 'name' && row[k] !== 0) acc[`MISSING_${k.toUpperCase()}`].push([k, row.id])
              }
              return acc
            }, errorsInTable)
          }
        }

        if (this.isAdjustIncreaseDecrease) {
          if (![PRODUCT_TYPE.DISCOUNT, PRODUCT_TYPE.NOTE, PRODUCT_TYPE.DECREE].includes(row.type) && !row.method) {
            errorsInTable.MISSING_METHOD.push(['method', row.id])
            // result = 'Cần chọn Điều chỉnh tăng hoặc giảm trên danh sách hàng hóa';
          } else if (row.method === 'GIAM' && row.total > 0) {
            const coords = [['price', row.id], ['subtotal', row.id]]
            errorsInTable.NON_NEGATIVE_DECREASE.push(...coords)
            // result = 'Dòng hóa đơn GIẢM, cần có số tiền tổng cộng là số âm trên danh sách hàng hóa';
          }
        }
      }
      return errorsInTable;
    },

    validateInvoice(promiseCallback, payload) {
      return new Promise((resolve, reject) => {
        this.$refs.form.submit();
        this.$refs.form.validate()
          .then((isValid) => {
            const errorItems = (this.$validator && this.$validator.errors && this.$validator.errors.items)
              ? this.$validator.errors.items
              : [];
            const bypassFields = ['buyer_name', 'buyer_legal_name'];
            const canBypassUnitValidation = errorItems.length > 0 && errorItems.every(e => bypassFields.includes(e.field));

            // Tạm bỏ validate "Đơn vị" (buyer_name / buyer_legal_name) để BE xử lý.
            if (isValid || canBypassUnitValidation) {
              const tableErrorMsg = this.detectValidationErrors(true);

              if (tableErrorMsg.length) {
                prevInvalidFields = tableErrorMsg;
                reject(null);
                return;
              }

              if (!tableErrorMsg.length && prevInvalidFields.length) {
                const tableRef = this.$refs.table
                prevInvalidFields.forEach(([field, id]) => {
                  tableRef.removeInvalidMarker(field, id.toString());
                });
                prevInvalidFields = []
              }

              if (promiseCallback && typeof promiseCallback === 'function') {
                this.isLoading = true;
                promiseCallback(payload)
                  .then(resolve)
                  .catch(reject);
              } else {
                ToastUtils.showToast('error', 'Invalid promiseCallback function.');
              }
            } else {
              if (errorItems.length > 0) {
                // Thứ tự trong items error dựa vào layout.
                if (
                  errorItems.length > 1
                  && errorItems[0].field === 'buyer_name'
                  && errorItems[1].field === 'buyer_legal_name'
                ) {
                  ToastUtils.showToast('error', 'Bạn cần tên người mua hoặc tên đơn vị.');
                  return;
                }
              }
              ToastUtils.showToast(
                'error',
                (errorItems[0] && errorItems[0].msg) ? errorItems[0].msg : 'Dữ liệu không hợp lệ'
              );
            }
          });
      });
    },

    evidenceForChange(data) {
      const { evidence_for_change: evidenceForChange } = data;
      const id = this.invoice.id_pinvoice;

      return new Promise((resolve, reject) => {
        this.$refs.form.submit();
        this.$refs.form.validate()
          .then((isValid) => {
            this.isLoading = true;

            const errorItems = (this.$validator && this.$validator.errors && this.$validator.errors.items)
              ? this.$validator.errors.items
              : [];
            const bypassFields = ['buyer_name', 'buyer_legal_name'];
            const canBypassUnitValidation = errorItems.length > 0 && errorItems.every(e => bypassFields.includes(e.field));

            // Tạm bỏ validate "Đơn vị" (buyer_name / buyer_legal_name) để BE xử lý.
            if (!isValid && !canBypassUnitValidation) {
              if (errorItems.length > 0) {
                // Thứ tự trong items error dựa vào layout.
                if (
                  errorItems.length > 1
                  && errorItems[0].field === 'buyer_name'
                  && errorItems[1].field === 'buyer_legal_name'
                ) {
                  ToastUtils.showToast('error', 'Bạn cần tên người mua hoặc tên đơn vị.');
                  reject(null);
                  return;
                }
              }
              ToastUtils.showToast(
                'error',
                (errorItems[0] && errorItems[0].msg) ? errorItems[0].msg : 'Dữ liệu không hợp lệ'
              );
              reject(null);
              return;
            }

            const tableErrorMsg = this.detectValidationErrors(true);

            if (tableErrorMsg.length) {
              prevInvalidFields = tableErrorMsg;
              reject(null);
              return;
            }

            if (!tableErrorMsg.length && prevInvalidFields.length) {
              const tableRef = this.$refs.table
              prevInvalidFields.forEach(([field, id]) => {
                tableRef.removeInvalidMarker(field, id.toString());
              });
              prevInvalidFields = []
            }

            if (typeof evidenceForChange.name !== 'string' || !id) {
              resolve(null);
              return;
            }

            const dataFile = new FormData();
            dataFile.append('evidence_for_change', evidenceForChange);

            const payload = {
              id,
              dataFile,
            };

            new PublishedInvoiceProxy()
              .evidenceForChangePublishedInvoice(payload)
              .then(resolve)
              .catch(reject);
          });
      });
    },

    tableChangeHandler(data, invoiceHasChanged) {
      this.tableData = data;
      this.invoiceDataChanged(invoiceHasChanged)
    },
    invoiceDataChanged(value) {
      this.invoiceHasChanged = value;
    },
    onChangeInvoiceType(invoiceType) {
      this.invoiceType = invoiceType;
    },

    onChangeCurrencyCode(currencyCode) {
      this.currencyCode = currencyCode;
    },

    onPreview() {
      let callback = null;
      const formData = this.$refs.form.getValues();
      const payload = {
        ...this.invoice,
        ...formData,
        ...(this.flag === INVOICE_ACTIONS.ADJUST_INFO ? {} : this.$refs.table.getTotals()),
        lines: this.tableData,
        is_draf_preview: true,
        include_info: this.invoiceType === '6',
        id: this.invoice.id_pinvoice,
        seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || undefined,
      };

      switch (this.flag) {
        case INVOICE_ACTIONS.ADJUST_INFO:
          callback = data => new PublishedInvoiceProxy().editPublishedInvoice(data);
          break;
        case INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE:
          callback = data => new PublishedInvoiceProxy().editProductPublishedInvoice(data);
          break;
        case INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE:
          callback = data => new PublishedInvoiceProxy().replacedPublishedInvoice(data);
          break;
        case INVOICE_ACTIONS.ISSUE_INVOICE:
        case INVOICE_ACTIONS.COPY_INVOICE:
          callback = data => new EInvoiceProxy().createEInvoice(data);
          break;
        default:
          break;
      }
      if (callback) {
        this.validateInvoice(callback, payload)
          .then((res) => {
            if (res) {
              this.isLoading = false;
              this.$modal.show('invoice-preview-modal', {
                invoiceId: this.invoice.id_pinvoice,
                buyerInfo: this.invoice.buyer_obj,
                mailHistories: this.invoice.mail_histories,
                invoiceCommonCode: this.invoice.invoice_common_code,
                pdfURL: `${res.preview_file}`,
              });
            }
          })
          .catch((error) => {
            this.isLoading = false;
            ToastUtils.showToast('error', error.message || error);
          });
      }
    },
    onClose() {
      this.initialize();
      this.$bus.emit('display-invoice-form-model', false);
      this.$modal.hide('actions-invoice-modal', { isOk: true });
    },

    onClick() {
      if (this.isDefault) {
        this.onClose();
      } else {
        this.onPreview();
      }
    },

    handelSubmitSuccess() {
      this.initialize();
      this.isLoading = false;
      this.$bus.emit('update-invoice-success');
      this.$modal.hide('actions-invoice-modal', { isOk: true });
      this.$router.push({ name: 'main.revenue', params: this.$route.params, query: { ...this.$route.query, statistics: 'HIDE' } }).catch(() => { });
    },

    async onSubmit() {
      switch (this.flag) {
        case INVOICE_ACTIONS.ADJUST_INFO:
          this.handleAdjustInfo();
          break;
        case INVOICE_ACTIONS.ADJUST_INCREASE_DECREASE:
          this.handleAdjustIncreaseDecrease();
          break;
        case INVOICE_ACTIONS.ISSUE_REPLACEMENT_INVOICE:
          this.handleIssueReplacementInvoice();
          break;
        case INVOICE_ACTIONS.COPY_INVOICE:
        case INVOICE_ACTIONS.ISSUE_INVOICE:
          this.handleIssueInvoice();
          break;
        case INVOICE_ACTIONS.EXPLAIN_INVOICE:
          this.handleExplainInvoice();
          break;
        default:
      }
    },

    handleAdjustInfo() {
      const formData = this.$refs.form.getValues();
      this.evidenceForChange(formData)
        .then((response) => {
          const changeData = {
            ...this.invoice,
            ...formData,
            lines: this.tableData,
            include_info: this.invoiceType === '6',
            id: this.invoice.id_pinvoice || this.invoice.id,
            date_create_original: formData.date_created,
            seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || null,
          };

          if (response && response.file_path) {
            changeData.file_path = response.file_path;
          }

          const payload = this.invoice.id_pinvoice
            ? changeData
            : {
              change_data: changeData,
              changed_invoice_data: this.invoice,
            };

          const promiseCallback = this.invoice.id_pinvoice ?
            data => new PublishedInvoiceProxy().editPublishedInvoice(data) :
            data => new InvoiceProxy().editInfoInvoice(data);

          this.handleInvoice(payload, promiseCallback)
            .then((res) => {
              if (res) {
                ToastUtils.showToast('success', 'Lập hoá đơn điều chỉnh thông tin thành công');
                this.handelSubmitSuccess();
              }
            }, (errorCode) => {
              this.isLoading = false;
              this.$modal.show('usb-token-error-modal', { model: { error: errorCode, flag: 'ACTIONS' } });
            });
        }).catch((error) => {
          this.isLoading = false;
          ToastUtils.showToast('error', error.message || error);
        });
    },

    handleAdjustIncreaseDecrease() {
      const formData = this.$refs.form.getValues();
      this.evidenceForChange(formData)
        .then((response) => {
          const total = this.tableData.reduce((acc, item) => acc + item.total, 0);
          let method = 'tăng';
          if (total < 0) {
            method = 'giảm';
          }

          const changeData = {
            ...this.invoice,
            ...formData,
            ...this.$refs.table.getTotals(),
            id: this.invoice.id_pinvoice || this.invoice.id,
            date_create_original: formData.date_created,
            lines: this.tableData,
            include_info: this.invoiceType === '6',
            seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || undefined,
          };

          const date = DateTimeUtils.formatDate(changeData.issued_date, 'DD/MM/YYYY');
          changeData.note_change = `điều chỉnh ${method} cho hóa đơn điện tử mẫu ${changeData.template_code} ký hiệu ${changeData.invoice_serial} số ${changeData.invoice_number} lập ${date} tiền: ${NumericUtils.formatNumber(total)}`;

          if (response && response.file_path) {
            changeData.file_path = response.file_path;
          }

          const payload = this.invoice.id_pinvoice
            ? changeData
            : {
              change_data: changeData,
              changed_invoice_data: this.invoice,
            };

          const promiseCallback = this.invoice.id_pinvoice ?
            data => new PublishedInvoiceProxy().editProductPublishedInvoice(data) :
            data => new InvoiceProxy().editProductInvoice(data);

          this.handleInvoice(payload, promiseCallback)
            .then((res) => {
              if (res) {
                ToastUtils.showToast('success', 'Lập hoá đơn điều chỉnh tăng giảm thành công');
                this.handelSubmitSuccess();
              }
            }, (errorCode) => {
              this.isLoading = false;
              this.$modal.show('usb-token-error-modal', { model: { error: errorCode, flag: 'ACTIONS' } });
            });
        }).catch((error) => {
          this.isLoading = false;
          ToastUtils.showToast('error', error.message || error);
        });
    },

    handleIssueReplacementInvoice() {
      const formData = this.$refs.form.getValues();
      this.evidenceForChange(formData)
        .then((response) => {
          const changeData = {
            ...this.invoice,
            ...formData,
            ...this.$refs.table.getTotals(),
            id: this.invoice.id_pinvoice || this.invoice.id,
            date_create_original: formData.date_created,
            lines: this.tableData,
            include_info: this.invoiceType === '6',
            seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || undefined,
          };

          if (response && response.file_path) {
            changeData.file_path = response.file_path;
          }

          const payload = this.invoice.id_pinvoice
            ? changeData
            : {
              change_data: changeData,
              changed_invoice_data: this.invoice,
            };

          const promiseCallback = this.invoice.id_pinvoice ?
            data => new PublishedInvoiceProxy().replacedPublishedInvoice(data) :
            data => new InvoiceProxy().replaceInvoice(data);

          this.handleInvoice(payload, promiseCallback)
            .then((res) => {
              if (res) {
                ToastUtils.showToast('success', 'Lập hoá đơn thay thế thành công');
                this.handelSubmitSuccess();
              }
            }, (errorCode) => {
              this.isLoading = false;
              this.$modal.show('usb-token-error-modal', { model: { error: errorCode, flag: 'ACTIONS' } });
            });
        }).catch((error) => {
          this.isLoading = false;
          ToastUtils.showToast('error', error.message || error);
        });
    },

    handleCancelInvoice() {
      const formData = this.$refs.form.getValues();
      formData.cancel_date = formData.agreement_date;
      const callback = data => new PublishedInvoiceProxy().cancelPublishedInvoice({ id: this.invoice.id_pinvoice, ...data });

      this.validateInvoice(callback, formData)
        .then((res) => {
          if (res) {
            ToastUtils.showToast('success', 'Hủy bỏ hoá đơn thành công');
            this.handelSubmitSuccess();
          }
        })
        .catch((error) => {
          this.isLoading = false;
          ToastUtils.showToast('error', error.message || error);
        });
    },

    handleIssueInvoice() {
      const formData = this.$refs.form.getValues();
      const payload = {
        ...this.invoice,
        ...formData,
        ...this.$refs.table.getTotals(),
        lines: this.tableData,
        include_info: this.invoiceType === '6',
      };

      delete payload.id;

      const callback = (data) => this.saveNewProducts(data.lines)
        .then(() => this.createAndReleaseInvoice(data));

      this.validateInvoice(callback, payload)
        .then((res) => {
          if (res) {
            ToastUtils.showToast('success', this.$t('invoice.invoiceIssued'));
            this.handelSubmitSuccess();
          }
        }, (errorCode) => {
          this.isLoading = false;
          this.$modal.show('usb-token-error-modal', { model: { error: errorCode, flag: 'ACTIONS' } });
        });
    },
    extractList(res) {
      if (Array.isArray(res)) return res;
      if (res && Array.isArray(res.results)) return res.results;
      if (res && Array.isArray(res.data)) return res.data;
      return [];
    },
    getDefaultProductCategoryId() {
      if (this.defaultProductCategoryIdPromise) {
        return this.defaultProductCategoryIdPromise;
      }

      this.defaultProductCategoryIdPromise = new ProductCategoryProxy()
        .list({ page: 1, page_size: 200 })
        .then((res) => {
          const categories = this.extractList(res);
          const defaultCategory = categories.find((item) => {
            const name = (item && item.name ? item.name : '').trim().toLowerCase();
            return name === DEFAULT_PRODUCT_CATEGORY_NAME.toLowerCase();
          });

          if (defaultCategory && defaultCategory.id != null) {
            return defaultCategory.id;
          }

          return new ProductCategoryProxy()
            .create({ name: DEFAULT_PRODUCT_CATEGORY_NAME })
            .then(created => (created && created.id != null ? created.id : null));
        })
        .catch(() => null);

      return this.defaultProductCategoryIdPromise;
    },
    saveNewProducts(invoiceLines = []) {
      const newLines = invoiceLines.filter((line) => {
        if (!line || line.type !== PRODUCT_TYPE.PRODUCT) return false;
        return !!line.name && !line.product_id;
      });

      if (newLines.length === 0) return Promise.resolve();

      const defaultCategoryIdPromise = this.getDefaultProductCategoryId();
      const savePromises = newLines.map(line => {
        const categoryIdPromise = line.category_id != null
          ? Promise.resolve(line.category_id)
          : defaultCategoryIdPromise;

        return categoryIdPromise
          .then((categoryId) => {
            const payload = buildProductPayloadFromInvoiceLine(line);
            if (categoryId != null) payload.category = categoryId;
            return new ProductProxy().create(payload);
          })
          .then((res) => {
            line.product_id = res && res.id ? res.id : null;
          })
          .catch(() => { });
      });

      return Promise.all(savePromises);
    },

    handleExplainInvoice() {
      const formData = this.$refs.form.getValues();
      formData.id = this.invoice.id_pinvoice;
      this.$refs.form.submit();
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) {
            this.isLoading = true;
            new EInvoiceServiceProxy().addExplanation(formData)
              .then((res) => {
                if (res) {
                  ToastUtils.showToast('success', 'Thêm giải trình thành công');
                  this.handelSubmitSuccess();
                }
              })
              .catch((error) => {
                this.isLoading = false;
                ToastUtils.showToast('error', error.message || error);
              });
          } else {
            if (this.$validator.errors.items.length > 0) {
              // Thứ tự trong items error dựa vào layout.
              if (this.$validator.errors.items[0].field === 'buyer_name' && this.$validator.errors.items[1].field === 'buyer_legal_name') {
                ToastUtils.showToast('error', 'Bạn cần tên người mua hoặc tên đơn vị.');
                return;
              }
            }
            ToastUtils.showToast('error', this.$validator.errors.items[0].msg);
          }
        })
        .catch(() => { });
    },

    handleEditDraftInvoice() {
      const vm = this;
      const formData = this.$refs.form.getValues();
      const payload = {
        ...this.invoice,
        ...formData,
        ...this.$refs.table.getTotals(),
        lines: this.tableData,
        include_info: this.invoiceType === '6',
        seller_template_announcement: this.activeAnnouncementLines.list_template_announcement[formData.invoice_common_code] || null,
      };
      vm.$refs.form.submit();
      return vm.$refs.form.validate().then((isValid) => {
        if (isValid) {
          // Nếu chỉ vướng lỗi "Đơn vị" thì tạm cho FE đi qua để BE kiểm tra/chặn.
          const tableErrorMsg = this.detectValidationErrors(true);
          if (tableErrorMsg.length) return;
          this.isLoading = true;
          this.handleDraftInvoice(payload)
            .then((res) => {
              if (res) {
                ToastUtils.showToast('success', 'Cập nhật hóa đơn nháp thành công');
                this.$bus.emit('update-invoice-success', { model: res });
                this.initialize();
                this.isLoading = false;
                this.$modal.hide('actions-invoice-modal', { isOk: true });
              }
            }, (error) => {
              this.isLoading = false;
              ToastUtils.showToast('error', error.message);
            });
        } else {
          if (this.$validator.errors.items.length > 0) {
            // Thứ tự trong items error dựa vào layout.
            if (this.$validator.errors.items[0].field === 'buyer_name' && this.$validator.errors.items[1].field === 'buyer_legal_name') {
              ToastUtils.showToast('error', 'Bạn cần tên người mua hoặc tên đơn vị.');
              return;
            }
          }
          ToastUtils.showToast('error', this.$validator.errors.items[0].msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.actions-invoice-modal-body {
  overflow-x: visible !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/actions-invoice/actions-invoice-modal.vue